import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default {
	init() {
		const sliders = document.querySelectorAll('.layout.cards.cards1 .cards-swiper');
		if (!sliders.length) return;

		function setEqualSlideHeights(sliderEl) {
			const slides = sliderEl.querySelectorAll('.swiper-slide');
			if (!slides.length) return;

			// Reset first so we can measure natural height
			slides.forEach((slide) => {
				slide.style.height = '';
			});

			let maxHeight = 0;
			slides.forEach((slide) => {
				maxHeight = Math.max(maxHeight, slide.getBoundingClientRect().height);
			});

			if (!maxHeight) return;
			slides.forEach((slide) => {
				slide.style.height = `${Math.ceil(maxHeight)}px`;
			});
		}

		function scheduleEqualize(sliderEl) {
			requestAnimationFrame(() => setEqualSlideHeights(sliderEl));
		}

		sliders.forEach((sliderEl) => {
			const paginationEl = sliderEl.querySelector('.swiper-pagination');
			const nextEl = sliderEl.querySelector('.swiper-button-next');
			const prevEl = sliderEl.querySelector('.swiper-button-prev');

			const swiper = new Swiper(sliderEl, {
				modules: [Navigation, Pagination],
				slidesPerView: 3,
				spaceBetween: 28,
				grabCursor: true,
				watchOverflow: true,
				observer: true,
				observeParents: true,
				pagination: {
					el: paginationEl,
					type: 'progressbar',
				},
				navigation: {
					nextEl,
					prevEl,
				},
				breakpoints: {
					0: { slidesPerView: 1 },
					769: { slidesPerView: 2 },
					1261: { slidesPerView: 3 },
				},
			});

			// Equalize heights after init, after images load, and on Swiper lifecycle events
			scheduleEqualize(sliderEl);
			swiper.on('init', () => scheduleEqualize(sliderEl));
			swiper.on('resize', () => scheduleEqualize(sliderEl));
			swiper.on('breakpoint', () => scheduleEqualize(sliderEl));
			swiper.on('slideChangeTransitionEnd', () => scheduleEqualize(sliderEl));
			swiper.on('imagesReady', () => scheduleEqualize(sliderEl));

			const imgs = sliderEl.querySelectorAll('img');
			imgs.forEach((img) => {
				if (img.complete) return;
				img.addEventListener('load', () => scheduleEqualize(sliderEl), { once: true });
			});

			if (window.ResizeObserver) {
				const ro = new ResizeObserver(() => scheduleEqualize(sliderEl));
				ro.observe(sliderEl);
			}
		});
	},
};
